<template>
  <div class="col-md-4">
    <div class="content-sidebar accordion" id="accordion">

      <!-- sort by ... -->
      <div class="form-group form-inline">
        <label for="sort">Sort by &nbsp;</label>
        <select id="sort" v-model="sortMethod" @change="sort"
                class="form-select">
          <option value="dateAndKind">Date and Kind</option>
          <option value="kindAndDate">Kind and Date</option>
        </select>
      </div>

      <!-- Two levels of heading, 1 and 2,  with corresponding nested loops. -->
      <template v-for="(category, index1) in categories">
        <div v-if="cdaSideBarContentByKindAndDate && cdaSideBarContentByKindAndDate.hasOwnProperty(category)" :key="getHeaderByKind(category)" class="card-top">
        <!-- <div v-for="(content1, key1, index1) in contents || cdaSideBarContentByKindAndDate"
           :key="getHeaderByKind(key1, content1, index1)" > -->
        <div v-if="Object.keys(cdaSideBarContentByKindAndDate[category]).length > 0" class="card">
          <!-- date header -->
          <div class="card-header" :id="category">
              <togglable-caret-header
                data-bs-toggle="collapse"
                class="header__link"
                :data-bs-target="'#collapse'+index1"
                :showCaret="true"
                :open="expanded">

                <a role="button" ref='"toggle-head:"+category'>
                  {{ getHeaderByKind(category) }}      <!-- either date or kind -->
                </a>
                <!-- top name of dropdown -->
                <!-- <watch-button-cda :measKind="key1" :items="content1"/> -->
              </togglable-caret-header>
              <watch-button-cda :measKind="category" :items="cdaSideBarContentByKindAndDate[category]"/>
          </div>
          
          <!-- list of items, e.g. procs, meas, diags -->
          <div :id="'collapse'+index1" :class="'collapse'+(expanded?' show':'')" ref="toggle-target'+index1">
            <div class="card-body">
              <ul class="list-group w-100">
                <!-- CDA grouped by date and kind -->
                <li v-for="(content2, key2) in cdaSideBarContentByKindAndDate[category]" :key="getHeaderByKind(key2)" ref='list-group-item' class="list-group-item">

                  <ul class="list-group w-100">

                    <li class="kind">{{ getHeaderByKind(key2) }}</li>   
                    <li v-for="item in content2" :key="item.kind+item.id" class="list-group-item">
                      <cda-visitable-item 
                        :item="item"
                        @selection-changed-event='onSelectionChanged'
                      />
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>

        </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import types from '@/data/types';
import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';
import CdaVisitableItem from '@/components/includes/cda/CdaVisitableItem';
import WatchButtonCda from '@/components/private-layouts/_partials/watch/WatchButtonCda'
import kinds from '@/constants/kinds';
import {
  getHeaderByKind
} from '@/data/getters';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'cda-content-side-bar',
  components: {
    'togglable-caret-header': TogglableCaretHeader,
    'cda-visitable-item': CdaVisitableItem,
    'watch-button-cda': WatchButtonCda
  },
  props: [ 'itemInfo' ,'ready'],
  data() {
    return {
      kinds,
      types,
      sortMethod: 'kindAndDate',
      contents: this.cdaSideBarContentByKindAndDate,
      selectedItem: null,
      categories: [ kinds.E_PROCEDURE, kinds.PROCEDURE, kinds.E_MEASURE, kinds.MEASURE, kinds.E_DIAGNOSIS, kinds.DIAGNOSIS, kinds.E_MEDICATION, kinds.MEDICATION, kinds.E_VACCINE, kinds.VACCINE, kinds.E_ALLERGY, kinds.ALLERGY, kinds.E_OTHER, kinds.OTHER ]
    }
  },
  computed: {
    ...mapGetters('login/cda', {
      cdaSideBarContentByKindAndDate: 'getCdaSideBarContentKindAndDate',
      cdaSideBarContentByDateAndKind: 'getCdaSideBarContentGrouped',
    }),
    expanded() {
      // console.log(this.cdaSideBarContentByKindAndDate)
      if(this.$route.params.type && 
        ( this.$route.params.type === types.vaccination ||
          this.$route.params.type === types.diagnosis ||
          this.$route.params.type === types.allergy ||
          this.$route.params.type === types.medication ) )
        return true;
      else
        return false;
    }
  },
  beforeDestroy() {
    delete this.kinds;
    this.kinds = null;
    delete this.sortMethod;
    this.sortMethod = null;
    delete this.contents;
    this.contents = null;
  },
  methods: {
    onSelectionChanged(selectedItem) {
      this.selectedItem = selectedItem;
    },
    getHeaderByKind,

    sort: function () {
      // this.sidebarContent = this.sortMethod;
      switch (this.sortMethod) {
        case 'dateAndKind':
          this.contents = this.cdaSideBarContentByDateAndKind;
          break;
        case 'kindAndDate':
          this.contents = this.cdaSideBarContentByKindAndDate;
          break;
        default:
          this.contents = this.cdaSideBarContentByKindAndDate;
      }
    },
  }

}
</script>

<style scoped lang="scss">
  .kind {
    padding: 0.5rem 1.0rem;
    width: 100%;
    text-align: center;
    font-weight: bold;
    list-style: none;
  }
  .content-sidebar {
    height: 90vh;
    overflow: scroll;
  }
  .card-top {
    background-color: white;
      &:nth-child(odd) {
          background-color: rgba(0, 0, 0, 0.03);
      }
  }
  .card {
    width: 100%;
    background-color: transparent;

    .card-header {
      border-bottom: none;
      padding-left: 1.0rem;
      background-color: transparent;
      display: table;
    }
    .card-body {
      font-size: 0.9rem;
      color: lighten(#000, 20%);
      padding: 0;
      background-color: rgba(0, 0, 0, 0.03);
    }
  }

  .list-group-item {
    border: none;
    display: inline-flex;
    background-color: transparent;
    padding: 0;
    /*padding: 0;*/
    cursor: pointer;
    border-bottom: 1px solid darken(#fff, 15%);
    /*&:nth-child(odd) {*/
      /*background-color: rgba(0, 0, 0, 0.03);*/
    /*}*/
  }
  .header__link {
    white-space: normal;
    // width: 100%;
    display: table-cell;
    vertical-align: middle;
    

    &:hover {
      cursor: pointer;
    }
  }
  .form-group {
    font-size: 14px;
  }

</style>
